import { tns } from './lib/tiny-slider.js';
import $ from 'jquery';

class TinySlider {
  constructor() {
    this._setup();
  }

  _setup() {
    var slider = tns({
      container: '#tiny-slider',
      mouseDrag: true,
      swipeAngle: false,
      gutter: 10,
      speed: 400,
      loop: true,
      autoplay: true,
      controlsPosition: "bottom",
      navPosition: "bottom",
      autoplayButtonOutput: false,
      controlsText: ['<i class="fas fa-angle-left"></i>', '<i class="fas fa-angle-right"></i>'],
      edgePadding: 50,
      responsive: {
        548: {
          items: 1,
          slideBy: 1,
        },
        768: {
          items: 2,
          slideBy: 2,
        },
        1024: {
          items: 4,
          slideBy: 4,
        }
      }
    });

    $('#tiny-slider').show();
  }
}

export default TinySlider;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/tinySlider/index.js